export function createLocaleLoader({
  loadMessages,
  setLocaleMessage,
  setLocale,
  defaultLocale,
  fallbackMap,
  attempts = 5,
}) {
  const loadedLanguages = new Set()
  const loadingPromises = new Map()

  async function loadSingleLanguage(locale) {
    if (loadedLanguages.has(locale)) {
      return
    }
    if (loadingPromises.has(locale)) {
      return loadingPromises.get(locale)
    }

    const promise = loadMessages(locale)
      .then((res) => {
        setLocaleMessage(locale, res.default)
        loadedLanguages.add(locale)
      })
      .finally(() => loadingPromises.delete(locale))
    loadingPromises.set(locale, promise)
    return promise
  }

  async function loadLanguage(locale, count = attempts) {
    try {
      const fallbackLocale = (fallbackMap[locale] || fallbackMap.default)[0]
      await loadSingleLanguage(locale)
      const fallbackLoaders = []
      if (locale !== defaultLocale) {
        fallbackLoaders.push(loadSingleLanguage(fallbackLocale))
        if (fallbackLocale !== defaultLocale) {
          fallbackLoaders.push(loadSingleLanguage(defaultLocale))
        }
      }
      await Promise.all(fallbackLoaders)
      setLocale(locale)
    } catch (err) {
      console.error(`[CAS] Failed to load language: ${locale}, attempts left: ${count}`, err)
      if (count > 1) {
        return loadLanguage(locale, count - 1)
      }
      if (locale !== defaultLocale) {
        return loadLanguage(defaultLocale, attempts)
      }
      console.error('[CAS] Critical: Failed to load any language')
      throw new Error('Failed to initialize i18n')
    }
  }

  return { loadLanguage }
}
